// [AFTER REBRAND] Delete this file, and clean up all files using it.

import useFeature from "./use-feature"

/**
 * Shorthand for the rebrand feature flipper.
 *
 * @returns {Boolean}
 */
export default function useRebrand() {
  const { enabled } = useFeature.static("rebrand_2024")

  return enabled
}
